/**
 * LoadingState Component
 * 
 * Full-page centered loading spinner.
 * Used while data is being fetched.
 */

import React from 'react';

export interface LoadingStateProps {
  /** Optional message to display below spinner */
  message?: string;
}

export function LoadingState({ message }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      {message && (
        <p className="mt-4 text-sm text-gray-600">{message}</p>
      )}
    </div>
  );
}
